import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { steps } from '../data/offer';
export function SystemSteps() {
  return <section className="relative w-full overflow-hidden bg-ink-950 py-20" aria-labelledby="sistema" data-id="element-174" data-mp="21k9tg61yqw30">
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" data-id="element-175" data-mp="1wl6y5dbsc488" />
      <div className="relative mx-auto max-w-5xl px-5" data-id="element-176" data-mp="1sjlg7dke8zr6">
        <SectionHeading eyebrow="El sistema" title={<span id="sistema" data-id="element-178" data-mp="1nsbqye2rbyft">7 pasos, en orden, sin adivinar</span>} subtitle="Cada paso tiene su plantilla, su prompt y su resultado esperado. Ejecutas uno, pasas al siguiente." data-id="element-177" data-mp="1sl4wh461vasy" />

        <ol className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-179" data-mp="1dv7cl0f5l79k">
          {steps.map((step, index) => <motion.li key={step.number} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4,
          delay: Math.min(index * 0.05, 0.3)
        }} className="group relative rounded-2xl border border-white/10 bg-ink-800/70 p-6 transition-colors hover:border-brand-cyan/40" data-id="element-180" data-mp="18ujclp8y5g37" data-mpi={index}>
              <span className="font-display text-3xl text-brand-cyan/80" data-id="element-181" data-mp="246g6wwoqwn0j">{step.number}</span>
              <h3 className="mt-3 text-base font-bold text-white" data-id="element-182" data-mp="297vr6mj3mphv">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-183" data-mp="2wyhxa89jlzp8">{step.description}</p>
            </motion.li>)}
          <li className="flex flex-col justify-center rounded-2xl border border-brand-red/40 bg-brand-red/10 p-6" data-id="element-184" data-mp="31u70clkrtyqa">
            <span className="font-display text-3xl text-brand-red" data-id="element-185" data-mp="2ry3q0sfrmts9">48h</span>
            <p className="mt-3 text-sm font-semibold leading-relaxed text-white" data-id="element-186" data-mp="2s06pe32t5z9n">
              Es el tiempo de ejecución del plan completo. No es una promesa de ingresos: es el
              plazo para tener tu máquina montada y funcionando.
            </p>
          </li>
        </ol>
      </div>
    </section>;
}